module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB3001-78b79ec1761c7386df546f88a8e952a2.png";